import { useState } from "react";
import { connect } from "react-redux";
import "./ActionsMenu.css";
import {
  redirectToAboutMePage,
  redirectToAnalyticsPage,
} from "../../core/Routing/RoutesRedirects";
import { getShareURL } from "../../utils/helpers/geralHelpers/RandomHelper";
import {
  renderEmailShareIconForApp,
  renderFacebookMessengerShareIcon,
  renderWhatsAppShareIcon,
} from "../../modules/Results/components/ExtraRenders";
import { BLACK } from "../../utils/constants/constants";
import { MAIN_PURPLE } from "../../utils/constants/colorsConstants";
import { setFlashProps } from "../../store/actions";
import EmailIcon from "../../assets/images/emailIconWhiteBackground.png";
import EmailIcon2 from "../../assets/images/emailIconWhiteBackground2x.png";
import EmailIcon3 from "../../assets/images/emailIconWhiteBackground3x.png";
import WhatsAppIcon from "../../assets/images/whatsappIconWhiteBackground.png";
import WhatsAppIcon2 from "../../assets/images/whatsappIconWhiteBackground2x.png";
import WhatsAppIcon3 from "../../assets/images/whatsappIconWhiteBackground3x.png";
import MessengerIcon from "../../assets/images/messengerIconWhiteBackground.png";
import MessengerIcon2 from "../../assets/images/messengerIconWhiteBackground2x.png";
import MessengerIcon3 from "../../assets/images/messengerIconWhiteBackground3x.png";
import { detectMessenger } from "../../utils/helpers/geralHelpers/messengerDetector";
import FLASH_TYPES from "../flash/FLASH_TYPES";
import { createAnalytic } from "../../utils/helpers/geralHelpers/BackendHelper";
import { EVENTS } from "../../utils/helpers/geralHelpers/EventsHelper";

/**
 * Functional Component: ActionsMenu
 * The hamburguer menu component
 *
 * @param {Object} currentUser
 * @param {Object} preliminaryResult
 * @param {Object} queryParams
 * @param {Function} setFlashProps
 * @param {Object} copies
 * @returns {Element}
 * */

const ActionsMenu = ({ currentUser, setFlashProps, language }) => {
  const [navbarOpen, setNavbarOpen] = useState(false);

  //closes the hamburguer menu
  const closeSelf = () => {
    document.getElementById("list").classList.remove("showMenu");
    document.getElementById("list").classList.add("closeMenu");
    document.body.style.overflowY = "visible";
    setNavbarOpen(false);
  };

  //opens the hamburguer menu
  const openSelf = () => {
    document.getElementById("list").classList.remove("closeMenu");
    document.getElementById("list").classList.add("showMenu");
    document.body.style.overflowY = "hidden";
    setNavbarOpen(true);
  };

  //handle the closing and opening of the hamburguer
  const handleToggle = () => {
    if (!navbarOpen) openSelf();
    else closeSelf();
  };

  /**
   * renders the X closing icon of the hamburguer
   *@returns {svg}
   */
  const renderXIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill={MAIN_PURPLE}
          d="m2.121 0 17.678 17.678-2.122 2.12L0 2.122z"
        />
        <path
          fill={MAIN_PURPLE}
          d="M0 17.678 17.678 0l2.121 2.122L2.122 19.799z"
        />
      </svg>
    );
  };

  /**
   * renders the opening icon for the hamburguer
   *@returns {svg}
   */
  const renderOpenIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="19"
        viewBox="0 0 25 19"
        fill="none"
      >
        <path fill={MAIN_PURPLE} d="M0 0h25v3H0zM0 8h25v3H0zM0 16h25v3H0z" />
      </svg>
    );
  };

  /**
   * renders the meet violet button
   * @returns {element}
   */
  const renderAboutUsButton = () => {
    return (
      <div>
        <button id="about-us-button" onClick={() => {}}>
          Meet violet
        </button>
      </div>
    );
  };

  /**
   * renders the login button
   * @returns {element}
   */
  const renderLoginButton = () => {
    return (
      <div>
        <button
          id="to-login-button"
          name="menu-login-button"
          onClick={() => {}}
        >
          Login
        </button>
      </div>
    );
  };

  /**
   * renders the sign up button
   * @returns {element}
   */
  const renderSignUpButton = () => {
    return (
      <div>
        <button
          name="menu-signup-button"
          id="signup-button"
          onClick={() => {}}
          style={{
            backgroundColor: "grey",
            color: "white",
            cursor: "not-allowed",
          }}
        >
          Sign up
        </button>
      </div>
    );
  };

  /**
   * renders the profile button icon
   * @returns {element}
   */
  const renderAboutMeIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="4%"
        height="4%"
        fill="black"
        color="black"
        className="bi bi-person-fill aboutme-icon"
        viewBox="0 0 16 16"
        style={{
          left: window.innerWidth < 576 ? "32%" : "38%",
          bottom: window.innerWidth < 576 ? "42.5%" : "46%",
        }}
      >
        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
      </svg>
    );
  };

  const renderOptions = () => {
    return (
      <>
        <div>{renderAboutUsButton()}</div>
        <div>{renderLoginButton()}</div>
        <div>{renderSignUpButton()}</div>
      </>
    );
  };

  return (
    <nav className="navBarActionMenu">
      <div className="hamburguer-button" onClick={handleToggle}>
        {navbarOpen ? renderXIcon() : renderOpenIcon()}
      </div>

      <ul id="list" className="menuNav">
        <div
          id="items-container"
          className="d-flex flex-column align-items-center justify-content-between"
        >
          <div
            id="first-element"
            className="d-flex flex-column justify-content-between align-items-center"
          >
            {renderOptions()}
          </div>
        </div>
      </ul>
    </nav>
  );
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser,
    preliminaryResult: state.preliminaryResult,
    queryParams: state.queryParams,
    language: state.language,
  };
};

export default connect(mapStateToProps, { setFlashProps })(ActionsMenu);
